import isNil from "lodash/isNil";
import { getAudienceSegmentbyId } from "../audiences/selectors";
import hash from "object-hash";

export function generateQuoteKeyFromQuote(quote) {
    return hash(quote);
}

export function getPointById(entities, pointId) {
    const { points } = entities;
    if (isNil(points)) {
        return null;
    }
    const point = points[pointId];
    if (isNil(point)) {
        return null;
    }
    const segments = point.segmentIds.reduce((acc, segmentId) => {
        const segment = getAudienceSegmentbyId(entities, segmentId);
        if (segment) {
            acc.push(segment);
        }
        return acc;
    }, []);
    return {
        ...point,
        segments
    };
}



// WEBPACK FOOTER //
// ./src/modules/results/selectors.js